<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-epigraph element-with-heading" epub:type="epigraph" id="epigraph">
<div class="heading heading-with-title heading-without-image" id="epigraph-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Introduction to Today I Remember</h1>
</div>
</div>
</div>
</div>
<div class="text" id="epigraph-text">
<p class="first first-in-chapter first-full-width"><i>This story is a companion piece to “Today I Am Paul” (found later in this book). To see the connection, you’ll have to read my novel,</i> Today I Am Carey<i>, available from Baen Books.</i></p>
<p class="subsq"><i>My father, A. John Shoemaker, was good at so many things I’m bad at: construction, welding, electrical work, auto mechanics, camping … I could go on. And my worlds of writing and programming were equally foreign to him. But one thing I got from him was his love of the circus, sheer amazement at people doing what no person should be able to do.</i></p>
<p class="subsq"><i>And so, I was thrilled in my teens to discover the early works of Barry B. Longyear, whose first published stories told of a world settled by a circus troupe lost in the stars. Those stories made me a lifelong Longyear fan. He was the </i>first<i> author whom I saw develop from the start of his career, and he made me believe that maybe someday I could be a writer, too. I still aspire to live up to his standard.</i></p>
<p class="subsq"><i>So, this story is dedicated to the memory of my father, A. John Shoemaker, and to Barry B. Longyear. Life with the circus is one long uninterrupted deeeeelight!</i></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introductiontotodayiremember.vue?4c519314